/* eslint-disable react-refresh/only-export-components */
import { createFileRoute } from '@tanstack/react-router';
import { useFeatures } from '@/hooks/useFeatures';
import {
  FACILITY_CAN_DO_NEW_INCOMING,
  FiberIncomingTable,
} from '../../../-components/FiberIncomingTable';
import { useFiberIncomingList } from '../../../-hooks/useFiberIncomingList';
import { useFiberSettings } from '../../../-hooks/useFiberSettings';

export const Route = createFileRoute(
  '/(client)/transactions/(pages)/(list)/incoming/',
)({
  component: IncomingTransactionsPage,
});

function IncomingTransactionsPage() {
  const listState = useFiberIncomingList();
  const { data: fiberSettings } = useFiberSettings();
  const canCreateIncoming =
    fiberSettings?.some(s => s.key === FACILITY_CAN_DO_NEW_INCOMING) ?? false;
  const { isFeatureEnabled } = useFeatures();
  const canImportIncoming =
    canCreateIncoming && isFeatureEnabled('incoming-transaction-upload');

  return (
    <FiberIncomingTable
      listState={listState}
      canCreateIncoming={canCreateIncoming}
      canImportIncoming={canImportIncoming}
    />
  );
}
